import { Component } from '@angular/core';
import { StepperQueries } from '../../../../core/store/stepper/stepper.queries';
import { OnboardingQueries } from '../../../../core/store/onboarding/onboarding.queries';
import { HttpService } from '../../../../core/services/http/http.service';
import { EntityQueries } from '../../../../core/store/entity/entity.queries';
import { BasePageComponent } from '../../../../core/components/component-base-page/base-page.component';
import { ConfigQueries } from '../../../../core/store/config/config.queries';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Component({
	selector: 'bcb-source-of-funds',
	templateUrl: './source-of-funds.component.html',
	styleUrls: ['./source-of-funds.component.scss'],
})
export class SourceOfFundsComponent extends BasePageComponent {
	componentLayoutClassList = ['col-12'];

	constructor(
		configQueries: ConfigQueries,
		entityQueries: EntityQueries,
		http: HttpService,
		onboardingQueries: OnboardingQueries,
		stepperQueries: StepperQueries,
		_snackBar: MatSnackBar
	) {
		super(
			configQueries,
			entityQueries,
			http,
			onboardingQueries,
			stepperQueries,
			_snackBar
		);
	}

	onStepComplete(): Observable<any> {
		return this.http.individualsCompleteStep(
			this.entity.id,
			this.currentStep.key
		);
	}
}
